/* ==========================================================================
   EZB I18N — first-visit language popup (Arabic / English) + runtime
   Arabic translation with RTL. The Arabic dictionary (ezb-i18n-ar.js,
   window.EZB_AR) loads ONLY when Arabic is chosen, so English visitors
   pay zero extra weight.
   ========================================================================== */
(function(){
  'use strict';
  var KEY = 'ezb_lang';
  var lang = null;
  try { lang = localStorage.getItem(KEY); } catch(e){}

  function norm(s){ return String(s).replace(/\s+/g,' ').trim(); }

  /* dynamic strings built by JS with numbers inside */
  var PATTERNS = [
    [/^Add to Cart — (.+)$/,               function(m){ return 'أضف إلى السلة — ' + m[1]; }],
    [/^Add (\d+) to Cart — (.+)$/,         function(m){ return 'أضف ' + m[1] + ' إلى السلة — ' + m[2]; }],
    [/^Add (\d+) Bundles? to Cart — (.+)$/,function(m){ return 'أضف ' + m[1] + ' حزمة إلى السلة — ' + m[2]; }],
    [/^Select your flavors \((\d+)\/(\d+)\)$/, function(m){ return 'اختر نكهاتك (' + m[1] + '/' + m[2] + ')'; }],
    [/^Your Cart \((\d+)\)$/,              function(m){ return 'سلتك (' + m[1] + ')'; }],
    [/^Add \$([\d.]+) more for a FREE Energyze Bottle$/, function(m){ return 'أضف ' + m[1] + ' USD إضافية واحصل على قارورة Energyze مجاناً'; }],
    [/^FREE Energyze Bottle unlocked — added to your cart$/, function(){ return 'حصلت على قارورة Energyze مجاناً — أُضيفت إلى سلتك'; }],
    [/^FREE gift — orders \$(\d+)\+$/,    function(m){ return 'هدية مجانية — للطلبات فوق ' + m[1] + ' USD'; }],
    [/^\$(\d+) — FREE bottle$/,             function(m){ return m[1] + ' USD — قارورة مجانية'; }]
  ];

  function translateText(t){
    var k = norm(t);
    if(!k) return null;
    var hit = window.EZB_AR && window.EZB_AR[k];
    if(hit) return hit;
    for(var i=0;i<PATTERNS.length;i++){
      var m = k.match(PATTERNS[i][0]);
      if(m) return PATTERNS[i][1](m);
    }
    return null;
  }

  var ATTRS = ['placeholder','aria-label','alt','title'];

  function walk(root){
    if(!root) return;
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function(n){
        var p = n.parentNode && n.parentNode.nodeName;
        if(p === 'SCRIPT' || p === 'STYLE' || p === 'NOSCRIPT') return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var node;
    while((node = w.nextNode())){
      var tr = translateText(node.nodeValue);
      if(tr && norm(node.nodeValue) !== tr){
        var lead = (node.nodeValue.match(/^\s*/) || [''])[0];
        var tail = (node.nodeValue.match(/\s*$/) || [''])[0];
        node.nodeValue = lead + tr + tail;
      }
    }
    var els = root.querySelectorAll ? root.querySelectorAll('[placeholder],[aria-label],[alt],[title]') : [];
    for(var i=0;i<els.length;i++){
      for(var a=0;a<ATTRS.length;a++){
        var v = els[i].getAttribute(ATTRS[a]);
        if(v){
          var tr2 = translateText(v);
          if(tr2) els[i].setAttribute(ATTRS[a], tr2);
        }
      }
    }
  }

  var obs = null, pending = null;
  function observe(){
    if(obs) return;
    obs = new MutationObserver(function(muts){
      clearTimeout(pending);
      pending = setTimeout(function(){
        obs.disconnect(); obs = null;   /* avoid observing our own writes */
        walk(document.body);
        observe();
      }, 60);
    });
    obs.observe(document.body, { childList:true, subtree:true, characterData:true });
  }

  function injectRtl(){
    if(document.getElementById('ezb-rtl')) return;
    var l = document.createElement('link');
    l.rel = 'stylesheet';
    l.href = 'https://fonts.googleapis.com/css2?family=Tajawal:wght@400;500;700;800&display=swap';
    document.head.appendChild(l);
    var s = document.createElement('style');
    s.id = 'ezb-rtl';
    s.textContent =
      'html[dir="rtl"] body{direction:rtl}' +
      'html[dir="rtl"] body,html[dir="rtl"] h1,html[dir="rtl"] h2,html[dir="rtl"] h3,html[dir="rtl"] h4,html[dir="rtl"] .h2,html[dir="rtl"] button,html[dir="rtl"] input,html[dir="rtl"] textarea{font-family:"Tajawal","Montserrat",sans-serif}' +
      'html[dir="rtl"] input,html[dir="rtl"] textarea{text-align:right}' +
      /* Marquees must keep LTR geometry or the -50% loop animation slides the
         content away and leaves the bar empty. Containers stay LTR (loop math
         intact, always moving, never empty); each pill/card flips back to RTL
         so the Arabic inside reads correctly. */
      'html[dir="rtl"] .announce,html[dir="rtl"] .announce-track,html[dir="rtl"] .statbar,html[dir="rtl"] .stat-track,html[dir="rtl"] .rev-marquee,html[dir="rtl"] .rev-track,html[dir="rtl"] .ing-marquee,html[dir="rtl"] .ing-track{direction:ltr}' +
      'html[dir="rtl"] .a-set>span,html[dir="rtl"] .stat-pill,html[dir="rtl"] .rev-card,html[dir="rtl"] .ing-card{direction:rtl}';
    document.head.appendChild(s);
  }

  function activateArabic(){
    document.documentElement.setAttribute('lang','ar');
    document.documentElement.setAttribute('dir','rtl');
    injectRtl();
    if(window.EZB_AR_READY){ walk(document.body); observe(); return; }
    /* The Arabic dictionary ships as several parts so each asset stays small.
       Every part does  window.EZB_AR = Object.assign(window.EZB_AR||{}, {...})
       so load order does not matter; we only walk once ALL parts have settled. */
    var urls = window.EZB_AR_URLS || (window.EZB_AR_URL ? [window.EZB_AR_URL] : []);
    if(!urls.length){ if(window.EZB_AR){ walk(document.body); observe(); } return; }
    var pending = urls.length;
    function done(){
      if(--pending > 0) return;
      window.EZB_AR_READY = true;
      walk(document.body); observe();
    }
    urls.forEach(function(u){
      var sc = document.createElement('script');
      sc.src = u;
      sc.onload = done;
      sc.onerror = done;   /* a missing part must not block the rest */
      document.head.appendChild(sc);
    });
  }

  function setLang(l){
    try { localStorage.setItem(KEY, l); } catch(e){}
    lang = l;
    if(l === 'ar'){ activateArabic(); }
    var pop = document.getElementById('ezbLangPop');
    if(pop) pop.remove();
    paintToggle();
  }

  /* small persistent switcher so the choice is never a one-way door */
  function paintToggle(){
    var t = document.getElementById('ezbLangToggle');
    if(!t){
      t = document.createElement('button');
      t.id = 'ezbLangToggle';
      t.type = 'button';
      t.setAttribute('aria-label','Switch language');
      t.style.cssText = 'position:fixed;bottom:14px;inset-inline-start:14px;z-index:190;border:1px solid rgba(33,30,30,.18);background:#fff;color:#211e1e;border-radius:999px;padding:.45rem .85rem;font-size:.78rem;font-weight:800;cursor:pointer;box-shadow:0 4px 16px rgba(33,30,30,.14)';
      t.addEventListener('click', function(){
        if(lang === 'ar'){ try{ localStorage.setItem(KEY,'en'); }catch(e){} window.location.reload(); }
        else { setLang('ar'); }
      });
      document.body.appendChild(t);
    }
    t.textContent = (lang === 'ar') ? 'English' : 'عربي';
  }

  function showPopup(){
    if(document.getElementById('ezbLangPop')) return;
    var d = document.createElement('div');
    d.id = 'ezbLangPop';
    d.style.cssText = 'position:fixed;inset:0;z-index:300;display:flex;align-items:center;justify-content:center;background:rgba(33,30,30,.55)';
    d.innerHTML =
      '<div style="background:#fff;border-radius:18px;max-width:340px;width:88vw;padding:1.8rem 1.5rem;text-align:center;box-shadow:0 20px 60px rgba(33,30,30,.35)">'
      + '<p style="font-weight:900;font-size:1.25rem;color:#211e1e;margin:0 0 .3rem;letter-spacing:.02em">Energyze</p>'
      + '<p style="font-weight:800;font-size:1rem;color:#211e1e;margin:0 0 .2rem">اختر لغتك</p>'
      + '<p style="font-size:.85rem;color:#545252;margin:0 0 1.1rem">Choose your language</p>'
      + '<button type="button" data-ezb-lang="ar" style="display:block;width:100%;padding:.85rem;border:0;border-radius:12px;background:var(--green,#1d5324);color:#fff;font-size:1rem;font-weight:800;cursor:pointer;margin-bottom:.55rem">العربية</button>'
      + '<button type="button" data-ezb-lang="en" style="display:block;width:100%;padding:.85rem;border:1.5px solid #ded5cd;border-radius:12px;background:#fff;color:#211e1e;font-size:1rem;font-weight:800;cursor:pointer">English</button>'
      + '</div>';
    d.addEventListener('click', function(e){
      var b = e.target.closest && e.target.closest('[data-ezb-lang]');
      if(b) setLang(b.getAttribute('data-ezb-lang'));
    });
    document.body.appendChild(d);
  }

  function init(){
    if(lang === 'ar'){ activateArabic(); }
    else if(!lang){ showPopup(); }
    paintToggle();
  }
  if(document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
